import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSignOutAlt,
  faSignInAlt,
} from '@fortawesome/free-solid-svg-icons';
import { logoutUrl, customAuthUrl } from '../libs/authUrls';

const apiKey = get(window, 'Meteor.settings.public.apiKey', process.env.REACT_APP_API_KEY);

export default class VideoNavBar extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
  }

  login = (e) => {
    e.preventDefault();
    window.location.href = customAuthUrl(null, [
      ['redirect_uri', window.location],
      ['disable_social_media', 'true'],
      ['apiKEY', apiKey],
    ]);
  }

  logout = () => {
    localStorage.clear();
    window.location.href = logoutUrl;
  }

  render() {
    const { user } = this.props;
    const username = get(user, 'profile.username', get(user, 'username'));

    return (
      <div>
        <nav className="navbar navbar-expand-lg ">
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <span className="navbar-brand" style={{ borderRightWidth: '0px' }}>
            <img src="https://trace.tv/wp-content/uploads/2016/11/logo_africa1.png" height="50" className="d-inline-block align-top" alt="" />
          </span>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0" />
            <form className="form-inline my-2 my-lg-0">
              {!username
                ? <button className="btn btn-outline-white my-2 my-sm-0" onClick={this.login}>
                  <FontAwesomeIcon icon={faSignInAlt} />&nbsp;
                  <FormattedMessage id="player_login" />
                </button>
                : <div className="dropdown">
                  <button className="btn dropdown-toggle btn-outline-white my-2 my-sm-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {username}
                  </button>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <span className="dropdown-item" onClick={this.logout}>
                      <FontAwesomeIcon size='1x' icon={faSignOutAlt} />&nbsp;
                      <FormattedMessage id="player_logout" />
                    </span>
                  </div>
                </div>
            }
            </form>
          </div>
        </nav>
      </div>
    );
  }
}
